import {
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
  Link
} from "@mui/material";
import React from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { baseURL } from "../Config/config";
import { Alert } from "@mui/material";
import selexsuite from "../images/SelexSuite copy.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

const Login = ({ handleNavigate }) => {
  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    isOpen: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, isOpen } = state;
  const navy = "#061d34";
  const location = useLocation();

  const from =
  typeof location.state?.from === "string"
    ? location.state.from
    : location.state?.from?.pathname || "/";


  const handleSnackbar = (value) => {
    setState({ ...state, isOpen: value });
  };

  const handleAuth = async () => {
    setLoading(true);
    const body = { username, password };

    try {
      let result = await fetch(`${baseURL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      result = await result.json();


      if (result.token) {
  handleNavigate(result.token);
  navigate(from, { replace: true });
} else {
        handleSnackbar(true);
      }
    } catch (error) {
      handleSnackbar(true);
    }

    setLoading(false);
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#eef3f8", position: "relative", overflow: "hidden" }}>

      

      <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={isOpen}
        autoHideDuration={4000}
        onClose={() => handleSnackbar(false)}
      >
        <Alert severity="error" sx={{ fontSize: "12px" }}>
          Wrong Username or Password!
        </Alert>
      </Snackbar>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: 15,
          position: "relative",
          zIndex: 2
        }}
      >
     

        {/* Title */}
        <Typography sx={{ fontSize: 30, mb: 3,fontWeight: 950,
            color: "#0078c9",
            letterSpacing: "-1.8px",
            lineHeight: 1.08, }}>
          User Login
        </Typography>

        {/* Card */}
        <Box
          sx={{
            width: 420,
            background: "#ffffff",
            borderRadius: "14px",
            padding: "52px",
            boxShadow: "0 12px 35px rgba(0,0,0,0.12)",
          }}
        >
          {/* Email */}
          <Typography sx={{ fontSize: 12, mb: 1, color: "#6b7280", letterSpacing: "1px" }}>
            EMAIL OR USERNAME
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 3,mt:2 }}>
            <PersonOutlineIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
            <TextField
              fullWidth
              variant="standard"
              placeholder="admin@selexsuite.com"
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{ disableUnderline: true }}
              inputProps={{ style: { fontSize: 16 } }}

            />
          </Box>

          {/* Password label row */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: 12, color: "#6b7280", letterSpacing: "1px" }}>
              PASSWORD
            </Typography>

           
          </Box>

          {/* Password */}
          <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 4 ,mt:2}}>
            <LockOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
            <TextField
              fullWidth
              type={showPassword ? "text" : "password"}
              variant="standard"
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleAuth()}
              InputProps={{ disableUnderline: true }}
                            inputProps={{ style: { fontSize: 16 } }}

            />
            <VisibilityOutlinedIcon
              sx={{ fontSize: 18, color: "#9ca3af", cursor: "pointer" }}
              onClick={() => setShowPassword(!showPassword)}
            />
          </Box>

          {/* Button */}
          <Button
            fullWidth
            onClick={handleAuth}
            sx={{
              height: 48,
              borderRadius: "8px",
              background: "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
              color: "#fff",
              fontWeight: 600,
              letterSpacing: "1px",
              textTransform: "uppercase",
              boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
              ":hover": {
                background: "linear-gradient(90deg, #095c9c 0%, #1f8bc7 100%)",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : (
              "Login"
            )}
          </Button>

         
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
